import { __assign } from "tslib";
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
var ShiftGroup = function (_a) {
    var children = _a.children, shiftAnimation = _a.shiftAnimation, direction = _a.direction;
    return (React.createElement(AnimatePresence, { custom: direction }, React.Children.map(children, function (childNode, idx) { return (React.createElement(motion.div, __assign({ transition: { x: { type: 'spring', stiffness: 300, damping: 30 } }, custom: direction, style: { position: 'absolute' } }, shiftAnimation(idx)), childNode)); })));
};
export default ShiftGroup;
